// eslint-disable-next-line no-useless-catch
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import Divider from '@material-ui/core/Divider'
import { COMPANY, PRODUCTION } from '../../Config/index'
import AccountActions from '../../Redux/AccountRedux'
import Configurator from '../Configurator'
import IconLearnMode from '../../Icons/IconLearnMode'
import IconMXDetails from '../../Icons/IconMXDetails'
import IconVisualizerOne from '../../Icons/IconVisualizerOne'
import IconVisualizerExecutive from '../../Icons/IconVisualizerExecutive'
import IconChevronRight from '../../Icons/IconChevronRight'
import IconFilter from '../../Icons/IconFilter'
import IconImage from '../../Icons/IconImage'
import { FILTER_OPTIONS } from '../../Containers/Collections/Collections'
import IconRemote from '../../Icons/IconRemote'
import L from '../L'
import Type from '../Type'
import {
  SimulationDescription,
  SimulationImg,
  StatusDot,
  Chip,
  StyledSimIcon,
  StyledSimulation,
} from './SimulationBanner-styles'

export const Status = props => (
  <L display="grid" flow="column" gap={1} jc="center" ai="center">
    <StatusDot status={props.status === 'active' ? 'success' : 'disabledDark'} />
    <Type variant="h4" color={props.status === 'active' ? 'success' : 'disabledDark'}>
      {props.status === 'active' ? 'Active' : 'No Signal'}
    </Type>
  </L>
)

const SimIcon = ({ to, icon, label, onClick }) => (
  <StyledSimIcon label={label} onClick={onClick}>
    {to ? <Link to={to}>{icon}</Link> : icon}
  </StyledSimIcon>
)

const SimulationFilters = ({ filters = [], activeFilters = [] }) => (
  <L display="grid" flow="column" ai="center" jc="flex-start" columns="min-content 1fr" gap={1}>
    <IconFilter color="#4A4A4A" />
    <L display="flex" wrap ai="flex-start" jc="flex-start" mY={-0.5} mX={-0.5}>
      {filters.map(
        filter => activeFilters.includes(filter) && <Chip key={`filter_${filter}`} name={FILTER_OPTIONS[filter]} />,
      )}
    </L>
  </L>
)

const Simulation = ({
  to,
  src,
  name,
  description,
  filters = [],
  activeFilters = [],
  iconsLeft,
  iconsRight,
  simulation,
}) => (
  <StyledSimulation>
    <Link to={to}>
      <SimulationImg className="simulation__img">{src ? <img src={src} alt={name} /> : <IconImage />}</SimulationImg>
    </Link>
    <L display="grid" gap={1.5} maxX="100%" width={{ md: '350px' }}>
      <Link to={to}>
        <Type variant="titleMedium" className="simulation__title">
          {name}
        </Type>
      </Link>
      <SimulationDescription variant="subtitle">
        <span
          dangerouslySetInnerHTML={{
            __html: description || 'No description available',
          }}
        />
      </SimulationDescription>
      {!!filters.length && !!activeFilters.length && (
        <SimulationFilters filters={filters} activeFilters={activeFilters} />
      )}
    </L>
    <L display={{ xx: 'flex', sm: 'none' }} ai="center" alignSelf="center" position="absolute" t="0" b="0" mYAuto r="0">
      <IconChevronRight />
    </L>
    <L
      display={{ xx: 'none', sm: 'grid' }}
      flow="column"
      gap={4}
      ai="center"
      color="secondaryHueLightish"
      height="100%"
    >
      {iconsLeft.map(icon => (
        <SimIcon
          key={`sim-icon_${icon.label}`}
          icon={icon.icon}
          label={icon.label}
          to={icon.to}
          onClick={() => {
            if (icon.onClick) icon.onClick(simulation)
          }}
        />
      ))}
      {iconsRight && iconsRight.length ? (
        <>
          <Divider orientation="vertical" light />
          {iconsRight.map(icon => (
            <SimIcon
              key={`sim-icon_${icon.label}`}
              icon={icon.icon}
              label={icon.label}
              to={icon.to}
              onClick={() => {
                if (icon.onClick) icon.onClick(simulation)
              }}
            />
          ))}
        </>
      ) : null}
      {/* <SimIcon
        to={`/marketing-experience/${collectionID}/${id}#details`}
        icon={<IconDetails />}
        label="Details"
      />
      <SimIcon
        to={`/marketing-experience/${collectionID}/${id}#embed`}
        icon={<IconEmbed />}
        label="Embed"
      /> */}
    </L>
    <L display={{ sm: 'none' }} position={{ xx: 'absolute' }} t="0" l="0" width="100%" height="100%">
      <Link to={to} style={{ width: '100%', height: '100%', display: 'block' }} />
    </L>
  </StyledSimulation>
)

const SimulationBanner = ({
  collections,
  collection,
  simulation,
  id,
  clickId,
  activeFilters,
  iconsLeft,
  iconsRight,
  image,
  bannerLink,
  history,
  isAssemble,
}) => {
  const [executiveConfiguratorOpen, setExecutiveConfiguratorOpen] = useState(false)
  const [oneConfiguratorOpen, setOneConfiguratorOpen] = useState(false)
  const [collectionList, setCollectionList] = useState([])
  const prodFeatureFlags = useSelector(({ firestore }) => firestore.composite.config?.[COMPANY]?.prodFeatureFlags)
  const dispatch = useDispatch()

  const setSimulation = (...rest) => {
    dispatch(AccountActions.AccountSetSimulation(...rest))
  }

  const openExecutiveConfigurator = () => setExecutiveConfiguratorOpen(true)
  const closeExecutiveConfigurator = () => setExecutiveConfiguratorOpen(false)
  const openOneConfigurator = () => setOneConfiguratorOpen(true)
  const closeOneConfigurator = () => setOneConfiguratorOpen(false)

  const launchRemote = () => {
    setSimulation(
      collection && collection.id,
      simulation.id,
      null,
      true,
      true,
      `/${collection ? collection.id : '_'}/${simulation.id}/remote`,
      true,
    )
    const { userAgent } = window.navigator
    if (userAgent.match(/iPad/i)) {
      setTimeout(() => {
        window.open(`/${collection ? collection.id : '_'}/${simulation.id}/remote`, '_blank')
      }, 500)
    }
  }

  const launchLearnMode = () => {
    setSimulation(
      collection && collection.id,
      simulation.id,
      null,
      true,
      true,
      `/${collection ? collection.id : '_'}/${simulation.id}/learn-mode`,
      true,
    )
    const { userAgent } = window.navigator
    if (userAgent.match(/iPad/i)) {
      setTimeout(() => {
        history.push(`/${collection ? collection.id : '_'}/${simulation.id}/learn-mode`)
      }, 500)
    }
  }

  useEffect(() => {
    if (collections) {
      const arr = []
      for (let i = 0; i < collections.length; i++) {
        if (collections[i].simulations.includes(simulation.id)) {
          arr.push(collections[i].id)
        }
      }
      setCollectionList(arr)
    }
  }, [collections])

  if (!simulation) return null

  const thumbnailUrl = simulation.thumbnail && simulation.thumbnail.signedUrl
  const to = bannerLink || `/${collection ? collection.id : collectionList[0]}/${simulation.id}/simulation-details`
  const multiIcon = {
    icon: <IconVisualizerExecutive id={`${clickId}_executive`} />,
    label: 'Multi',
    onClick: () => openExecutiveConfigurator(),
  }

  const left = iconsLeft || [
    {
      icon: <IconVisualizerOne id={`${clickId}_one`} />,
      label: 'One',
      onClick: () => openOneConfigurator(),
    },
  ]
  if (!isAssemble && !simulation?.featureFlags?.isMultiVisualizerDisabled && Array.isArray(left)) left.push(multiIcon)

  const right = iconsRight || [
    {
      icon: <IconMXDetails id={`${clickId}_details`} />,
      label: 'Details',
      to,
    },
  ]
  const learnModeTab = {
    icon: <IconLearnMode id={`${clickId}_learnMode`} />,
    label: 'Learn Mode',
    onClick: () => launchLearnMode(),
  }

  const remoteTab = {
    icon: <IconRemote id={`${clickId}_remote`} />,
    label: 'Remote',
    onClick: () => launchRemote(),
  }
  if (!PRODUCTION && !iconsRight) {
    right.splice(0, 0, remoteTab, learnModeTab)
  } else {
    if (prodFeatureFlags?.isLearnModeEnabled && !simulation?.featureFlags?.isLearnModeDisabled && !iconsRight) {
      right.unshift(learnModeTab)
    }
    if (prodFeatureFlags?.isRemoteEnabled && !simulation?.featureFlags?.isRemoteDisabled && !iconsRight) {
      right.unshift(remoteTab)
    }
  }

  return (
    <>
      <Simulation
        id={id}
        to={to}
        src={image || thumbnailUrl}
        name={simulation.name}
        description={simulation.description}
        filters={simulation.filters}
        activeFilters={activeFilters}
        iconsLeft={left}
        iconsRight={right}
        simulation={simulation}
      />
      {executiveConfiguratorOpen && (
        <Configurator
          variant="executive"
          collection={collection}
          simulation={simulation}
          onClose={closeExecutiveConfigurator}
        />
      )}
      {oneConfiguratorOpen && (
        <Configurator variant="one" collection={collection} simulation={simulation} onClose={closeOneConfigurator} />
      )}
    </>
  )
}

SimulationBanner.propTypes = {
  simulation: PropTypes.shape().isRequired,
  collection: PropTypes.shape(),
  activeFilters: PropTypes.array,
  iconsLeft: PropTypes.array,
  iconsRight: PropTypes.array,
  image: PropTypes.string,
  bannerLink: PropTypes.string,
}
SimulationBanner.defaultProps = {
  collection: null,
  activeFilters: [],
}

export default withRouter(SimulationBanner)
